import { createReducer } from '@reduxjs/toolkit';
import * as pageActions from '../actions/page.action';

export const initialState = {};

const setPage = (state, { payload }) => {
  state[payload.id] = {
    ...state[payload.id],
    ...payload
  };
};

const setPageAttribute = attribute => (state, { payload }) => {
  state[payload.id] = {
    ...state[payload.id],
    [attribute]: payload[attribute] ?? state[payload.id][attribute]
  };
};

const duplicatePage = (state, { payload }) => {
  const { id, basedOn } = payload;

  state[id] = {
    ...state[basedOn],
    id,
    basedOn
  };
};

const deletePage = (state, { payload }) => {
  delete state[payload.id];
};

export default createReducer(initialState, builder => {
  builder
    .addCase(pageActions.createPageThumbnail.fulfilled, setPageAttribute('thumbnail'))
    .addCase(pageActions.deletePage, deletePage)
    .addCase(pageActions.duplicatePage, duplicatePage)
    .addCase(pageActions.setPage.fulfilled, setPage)
    .addCase(pageActions.setPageContent, setPageAttribute('content'));
});
